import React from 'react';
import { Modal } from 'antd';

interface IProps {
  isModalOpen: boolean;
  handleOk: () => void;
  handleCancel: () => void;
  loading: boolean;
}

const ReviewModal = ({ isModalOpen, handleOk, handleCancel, loading }: IProps) => {
  return (
    <Modal
      title="Confirm Acceptance"
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText="Accept All"
      cancelText="Cancel"
    >
      <p>Are you sure you want to accept all keypoints on this page that are not yet reviewed?</p>
    </Modal>
  );
};

export default ReviewModal;
